export default __webpack_public_path__ + "static/kislev-0b30e3e59a6e5b599bafd1a79c25f3f2.webp";